/**
 * GenericButton component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled generic button.
 */
const GenericButton = styled.button<Props>`
  align-items: center;
  background: ${(props) =>
    props.displayBackground
      ? Colors['modal']['button']['light']
      : 'transparent'};
  border: ${Colors['modal']['button']['light']} ${3 * Screen.widthRatio}px solid;
  border-radius: ${40 * Screen.widthRatio}px;
  color: ${(props) =>
    props.displayBackground
      ? Colors['modal']['button']['text']
      : Colors['light']};
  cursor: pointer;
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${36 * Screen.widthRatio}px;
  height: ${80 * Screen.widthRatio}px;
  min-width: ${300 * Screen.widthRatio}px;
  justify-content: center;
  padding: 0 ${20 * Screen.widthRatio}px;
  z-index: 1;
  &:hover {
    background: ${Colors['modal']['button']['light']};
    color: ${Colors['modal']['button']['text']};
  }
`;

export default withOpacity(GenericButton);
